import { useActivePage } from "./useActivePage";

export function useActivePagePath(): string {
  const activePage = useActivePage();

  return activePage?.path ?? window.location.pathname;
}
